export function SortNew(jobType) {
    return {
        type: 'design/jobSort/SORT_NEW',
        payload: jobType,
    };
}

export function SortOld(jobType) {
    return {
        type: 'design/jobSort/SORT_OLD',
        payload: jobType,
    };
}

export function SortAtoZ(jobType) {
    return {
        type: 'design/jobSort/SORT_AZ',
        payload: jobType,
    };
}

export function newSearch(term, jobType) {
    return {
        type: 'design/new/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function fullSearch(term, jobType) {
    return {
        type: 'design/full/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function completeSearch(term, jobType) {
    return {
        type: 'design/complete/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function filter(filterBy, jobType) {
    return {
        type: 'design/FILTER',
        filterBy: filterBy,
        jobType: jobType,
    };
}